// A copy of what the counselor typed, kept in this browser until the server has it.
// One entry per appointment and field ("prep" or "notes"); removed once saved.

const PREFIX = 'anna.notes.';
const keyFor = (id, field) => `${PREFIX}${id}.${field}`;

const storage = () => {
  try {
    return window.localStorage;
  } catch (error) {
    return null;
  }
};

/** { text, at } or null. */
export const readDraft = (id, field) => {
  const store = storage();
  if (!store) return null;
  try {
    const raw = store.getItem(keyFor(id, field));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed.text === 'string' ? parsed : null;
  } catch (error) {
    return null;
  }
};

export const writeDraft = (id, field, text) => {
  const store = storage();
  if (!store) return;
  try {
    store.setItem(keyFor(id, field), JSON.stringify({ text, at: new Date().toISOString() }));
  } catch (error) {
    // Storage full or blocked: the server copy is all there is.
  }
};

export const clearDraft = (id, field) => {
  const store = storage();
  if (!store) return;
  try {
    store.removeItem(keyFor(id, field));
  } catch (error) {
    // Nothing to clear.
  }
};

/** Every draft on this browser, for signing out on a shared computer. */
export const clearAllDrafts = () => {
  const store = storage();
  if (!store) return;
  try {
    Object.keys(store)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => store.removeItem(key));
  } catch (error) {
    // Nothing to clear.
  }
};
